import { Button, Component, Enum, warn, _decorator } from 'cc';
import Lobby from '../../../../System/Lobby';
import Page from '../../../../../common/scripts/Toolkit/Components/Page/Page';
import Delay from '../../../../../common/scripts/Toolkit/Utils/Delay';

const { ccclass, property, requireComponent } = _decorator;

enum AfterOpenAction {
    None,
    CloseBelongPage,
    ReopenBelongPageAfterClose,
}

@ccclass('OpenPageButton')
@requireComponent(Button)
export default class OpenPageButton extends Component {
    @property({
        type: Page,
        visible() {
            return !this.popupName;
        },
    })
    private readonly externalPage: Page = null;

    @property({
        visible() {
            return !this.externalPage;
        },
    })
    private readonly popupName: string = '';

    @property({ type: Enum(AfterOpenAction) })
    private readonly afterOpenAction: AfterOpenAction = AfterOpenAction.CloseBelongPage;

    private _page: Page = null;
    private _belongPage: Page = null;

    private get belongPage() {
        if (!this._belongPage) {
            this._belongPage = this.getComponentInParent(Page);
        }
        return this._belongPage;
    }

    private get page() {
        if (!this._page) {
            const pageNode = Lobby.scene.getNode(this.popupName);
            if (!pageNode) {
                warn(`Can't find page with name: ${this.popupName}`);
                return null;
            }
            this._page = pageNode.getComponent(Page);
        }
        return this._page;
    }

    protected onLoad() {
        this.node.on(Button.EventType.CLICK, () => {
            const page = this.externalPage ?? this.page;
            page.open();
            if (this.afterOpenAction !== AfterOpenAction.None) {
                const { belongPage } = this;
                if (!belongPage) {
                    warn("Can't find belong page");
                    return;
                }
                this.belongPage.close();
                if (this.afterOpenAction === AfterOpenAction.ReopenBelongPageAfterClose) {
                    Delay.event(Page.EVENT_TYPE.CLOSE_END, page).then(() => belongPage.open());
                }
            }
        });
    }
}
